



























import { $store } from "@/store";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SaveLayoutForm extends Vue {
  @Prop()
  step!: number;

  loading = false;

  get isCurrentStep() {
    return this.step == $store.wizard.layoutStep;
  }

  get isSingleUse() {
    return (
      $store.wizardInstances.wizardInstance?.config.layout?.flow == "single-use"
    );
  }

  cancelSave() {
    $store.wizard.layoutStep--;
  }

  async saveLayout() {
    this.loading = true;
    const [layout, err] = await $store.layouts.save();
    this.loading = false;
    if (err) {
      // Show error page
    } else {
      $store.wizard.exitWizard({ layoutId: layout?.id, result: "created" });
    }
  }
}
